
import React from "react";
import { Control } from "react-hook-form";
import FormInput from "../common/FormInput";

interface PersonalInfoFieldsProps {
  control: Control<any>;
  defaultValues?: {
    firstName?: string;
    lastName?: string;
    email?: string;
  };
  disabled?: boolean;
}

const PersonalInfoFields: React.FC<PersonalInfoFieldsProps> = ({
  control,
  defaultValues = {},
  disabled = false
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <FormInput
        control={control}
        name="firstName"
        label="First Name"
        placeholder="Enter your first name"
        autoComplete="given-name"
        required
        disabled={disabled}
        defaultValue={defaultValues.firstName}
      />
      
      <FormInput
        control={control}
        name="lastName"
        label="Last Name"
        placeholder="Enter your last name"
        autoComplete="family-name"
        disabled={disabled}
        defaultValue={defaultValues.lastName}
      />
      
      <FormInput
        control={control}
        name="email"
        label="Email"
        placeholder="Enter your email"
        autoComplete="email"
        required
        disabled={disabled}
        defaultValue={defaultValues.email}
        className="md:col-span-2"
      />
    </div>
  );
};

export default PersonalInfoFields;

